import { useEffect, useState } from 'react'
import { Navigate } from 'react-router-dom'

import { useMe } from '../../hooks/queries'
import { letzterChat } from '../../lib/letzterChat'

/**
 * Beim Öffnen der Anwendung: zurück in den zuletzt offenen Chat.
 *
 * Und zwar **einmal je Start**, nicht bei jedem Besuch der Übersicht. Sonst
 * wäre der Weg zur Liste versperrt: jedes „Zurück" fiele sofort wieder in den
 * Chat, aus dem man gerade gekommen ist. Die Marke steht deshalb im Modul und
 * nicht im Gerät -- sie gilt für diese Sitzung, nicht für die nächste.
 */
let verbraucht = false

/** Was rechts steht, solange kein Chat geöffnet ist. Am Telefon nie sichtbar. */
export function StartPane() {
  const me = useMe()
  // Gelesen wird erst hier und nicht beim Laden des Moduls: kommt man von
  // einer verschwundenen Reise, ist die Erinnerung inzwischen gelöscht, und
  // ein früher gemerkter Wert schickte einen geradewegs dorthin zurück.
  //
  // Im Anfangswert wird nur gelesen, nicht verbraucht: React ruft ihn in der
  // Entwicklung zweimal auf.
  const [ziel] = useState(() => (verbraucht ? null : letzterChat()))

  useEffect(() => {
    verbraucht = true
  }, [])

  // Kein `replace`: der Schritt bleibt in der Geschichte des Browsers stehen,
  // damit der Zurück-Knopf zur Liste führt und nicht aus der Anwendung heraus.
  if (ziel !== null) return <Navigate to={ziel} />

  return (
    <div className="empty">
      <p className="empty__title">Travel Broadcast</p>
      {me.data?.may_create_trips ? (
        <p>
          Wähle links eine Reise aus oder lege eine neue an.
          <br />
          Was du schreibst, lesen alle Empfänger. Was sie antworten, liest nur du.
        </p>
      ) : (
        <p>
          Wähle links eine Reise aus.
          <br />
          Deine Antworten liest nur der Reisende – die anderen Empfänger nicht.
        </p>
      )}
    </div>
  )
}
